import React from 'react'
import { Link } from "react-router-dom";

const DevExperience = () => {
  return (
    <div className="Job-listing">
      <p>
        At Dark, we’re making it radically easier to build backends.
        Working in developer experience, you’ll interface with our developer community,
        write a lot of code, and help prioritize features.
      </p>
      <p>
        This is an early stage opportunity; we’re still in private beta.
        You’ll have a lot of flexibility, but starting from solid materials:
        we’ve heard things like “most impressive live coding demo that I've seen
        in a long time” and "I felt like I got a glimpse into the future.”
      </p>
      <p>
        You’ll help define our community from the ground up!
        We care about building a welcoming, helpful community, and we want to make sure we do
        that from the very beginning.
      </p>
      <p>
        We think some pieces of this will be:
      </p>
      <ul>
        <li>Onboarding new developers to Dark.</li>
        <li>
          Talking to users in real time to help them answer questions about the
          platform, language, and best practices.
        </li>
        <li>Using those learnings to write documentation and sample code.</li>
        <li>Picking tooling to support our documentation and community discussions.</li>
        <li>Building and sharing your own applications using Dark.</li>
        <li>Sharing Dark at conferences, hackathons, meetups, and other events.</li>
        <li>Championing users in product discussions.</li>
      </ul>
      <p>
        You’ll help decide which of these pieces make sense for you and would
        have the most impact. We’ll consider you part of the product &amp;
        engineering team, and you’ll report directly to the CEO.
      </p>
      <p>We hope you:</p>
      <ul>
        <li>Are motivated by helping other developers ship their ideas.</li>
        <li>
          Have built a few projects for a previously role, or for fun, that you’d love to show us (frontend, backend, IoT - we’d love to see them!)
        </li>
        <li>
          You don’t need to have had a formal developer experience/evangelism/advocate title: we’d love to
          hear from engineers who have done a talk or two and are interested in
          doing more work with the community.
        </li>
      </ul>
      <p>
        To apply, email{" "}
        <a href="mailto:careers@darklang.com">careers@darklang.com</a> and let
        us know why you're interested. You may also be interested in looking at our{" "}
        <Link to="/about#values">values</Link>.
      </p>
    </div>
  )
}

export default DevExperience
